import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class BaseComponent extends Vue {

    protected loading: boolean = false;



    mounted() {
       document.querySelector('body').classList.add('' + this.$options.name);

    }

    beforeDestroy() {
        document.querySelector('body').classList.remove('' + this.$options.name);

    }

}
